import React from "react";
import {css} from "@emotion/css";
import {FormCard, SelectField} from "@reside/ui";
import {useFormikContext} from "formik";
import {OrganizationModel} from "../../../utils/types/organization";
import {CreateStaffUserDto} from "../../../utils/types/user";

export const OrganizationSelect = ({
  organizations,
  disabled = false,
}: {
  organizations: readonly OrganizationModel[];
  disabled: boolean;
}): JSX.Element => {
  const {setFieldValue} = useFormikContext<CreateStaffUserDto>();

  return (
    <FormCard title="Organization">
      <SelectField<OrganizationModel>
        getOptionLabel={option => option.name}
        getOptionValue={option => option.id}
        label="Select Organization"
        name="organizationId"
        options={organizations}
        className={css(`
& > select {
padding-left: 0px;
}
`)}
        disabled={disabled}
        onChange={() => setFieldValue("facilities", [])}
      />
    </FormCard>
  );
};
